module.exports = __webpack_public_path__ + "img/light.c3729893.png";